import React, { useState } from 'react';

const TYPES = [
  { value: 'RESTOCK', label: 'Restock' },
  { value: 'ISSUE', label: 'Issue' },
  { value: 'RETURN', label: 'Return' },
];

export default function AddInventoryTransaction({ item, onClose, onSaved }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    transaction_type: 'RESTOCK',
    quantity: '',
    notes: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { inventoryAPI } = await import('../../services/api');
      await inventoryAPI.addTransaction(item.id, {
        transaction_type: form.transaction_type,
        quantity: parseFloat(form.quantity),
        notes: form.notes || undefined,
      });
      onSaved();
    } catch (err) {
      alert(err.message || 'Failed to record transaction');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 p-4">
      <div className="ga-card w-full max-w-md p-6 space-y-4">
        <h2 className="text-lg font-semibold text-ga-text-primary">Record transaction</h2>
        <p className="text-sm text-ga-text-muted">{item.item_name} — {Number(item.quantity_on_hand).toLocaleString()} {item.unit} on hand</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-ga-text-muted mb-1">Type</label>
            <select
              value={form.transaction_type}
              onChange={(e) => setForm((f) => ({ ...f, transaction_type: e.target.value }))}
              className="ga-input w-full px-4 py-2"
            >
              {TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-ga-text-muted mb-1">Quantity *</label>
            <input
              type="number"
              min="0.01"
              step="0.01"
              required
              value={form.quantity}
              onChange={(e) => setForm((f) => ({ ...f, quantity: e.target.value }))}
              className="ga-input w-full px-4 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-ga-text-muted mb-1">Notes</label>
            <input
              type="text"
              value={form.notes}
              onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
              className="ga-input w-full px-4 py-2"
              placeholder="Optional"
            />
          </div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={onClose} className="ga-btn-ghost px-4 py-2">Cancel</button>
            <button type="submit" disabled={loading} className="ga-btn-primary px-4 py-2">
              {loading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
